export const values = {
  Required: 'Required',
  AwaitingOutcome: 'AwaitingOutcome',
  Completed: 'Completed',
}
